import gsap from 'gsap'

export const footer = () => {

	const el = document.querySelector('[data-el="services-prompt"]');

	if (el) {
		el.addEventListener("click", () => {
			if (el.parentElement.getAttribute("data-status") === "show-nav") {
				el.parentElement.removeAttribute("data-status");
			} else {
				el.parentElement.setAttribute("data-status", "show-nav");
			}
		});
	}

}

export default () => { }